import React, { useEffect, useState } from 'react'
import axios from 'axios';

const withTenant = (Component) => {

    const Wrapper =  (props)=>{ 
        //console.log('withTenant: => Starting');
        const pathname = window.location.pathname;
        const usernameTenant  = pathname.split('/')[1];
        const [isTenant,setIsTenant] = useState(false);

        const safeParse = (value) => {
            if (!value) return null;
            try {
                return JSON.parse(value);
            } catch {
                return null;
            }
        };

        const redirectToAuth = () => {
            window.location.replace(`${process.env.REACT_APP_Auth_WEB_BASE_URL}`)
        };

        const getTenant = async() => {
            const cachedTenant = safeParse(localStorage.getItem('tenant'));
            const cachedTenantMatchesPath = cachedTenant?.username && cachedTenant.username === usernameTenant;

            if(!usernameTenant){
                if(cachedTenant){
                    setIsTenant(true);
                    return;
                }
                redirectToAuth();
                return;
            }

            if(!cachedTenantMatchesPath) {
                try{
                    const res = await axios.get(`${process.env.REACT_APP_Auth_API_BASE_URL}/tenants/username/${usernameTenant}`);
                    const _data = res?.data?.data;
                    if(_data){
                        localStorage.setItem('tenant',JSON.stringify(_data));
                        setIsTenant(true);
                    }else{
                        redirectToAuth();
                    }
                }catch(err){
                    console.log(err);
                    redirectToAuth();
                }
            }else{
                setIsTenant(true);
            }
        }
        useEffect(()=>{
           
            getTenant();
        },[]);

        if(isTenant){
            //console.log('withTenant: => is Ready');
            return   <Component {...props} /> 
        }
        

    }
    return Wrapper;
}

export default withTenant
